import { Routes } from "@angular/router";
import { centralRoutes } from "./pages/central/central.routes";
import { configuracionRoutes } from "./pages/configuracion/configuracion.routes";
import { gestionPersonasRoutes } from "./pages/gestion-personas/gestion-personas.routes";
import { haberesRoutes } from "./pages/haberes/haberes.routes";
import { licenciasRoutes } from "./pages/licencias/licencias.routes";
import { tyaRoutes } from "./pages/tiempo_y_asistencia/tiempo_y_asistencia.routes";
import { vacacionesRoutes } from "./pages/vacaciones/vacaciones.routes";
import { authRoutes } from "./pages/auth/auth.routes";
import { AuthGuard } from "./core/guards/auth-guard.service";
import { DeveloperOnlyGuard } from "./core/guards/developer-only.guard";
import { cambiosSinGuardarGuard } from "./core/guards/cambios-sin-guardar.guard";
import { herramientaPlantillasGuard } from "./core/guards/herramienta-plantillas.guard";
import { medicinaLaboralRoutes } from "@pages/medicina-laboral/medicina-laboral.route";
import { organizacionRoutes } from "@pages/organizacion/organizacion.route";
import { seleccionPersonalRoutes } from "@pages/seleccion-personal/seleccion-personal.route";

export const appRoutes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },

  // PUBLICO
  {
    path: "login",
    loadComponent: () =>
      import("./pages/auth/auth.component").then((m) => m.AuthComponent),
    children: authRoutes,
  },

  // PRIVADO
  {
    path: "",
    canActivate: [AuthGuard],
    children: [
      ...organizacionRoutes,
      ...seleccionPersonalRoutes,
      ...configuracionRoutes,
      ...centralRoutes,
      ...gestionPersonasRoutes,
      ...haberesRoutes,
      ...licenciasRoutes,
      ...tyaRoutes,
      ...vacacionesRoutes,
      {
        path: "dev_test",
        loadComponent: () =>
          import("./pages/configuracion/components/dev-test/dev-grid-test.component").then(
            (m) => m.DevGridTestComponent,
          ),
        canActivate: [DeveloperOnlyGuard],
      },
      {
        path: "dev_plantillas-reportes",
        loadComponent: () =>
          import(
            "./pages/configuracion/components/plantillas-reportes/plantillas-reportes.component"
          ).then((m) => m.PlantillasReportesComponent),
        canActivate: [herramientaPlantillasGuard],
        canDeactivate: [cambiosSinGuardarGuard],
      },
      ...medicinaLaboralRoutes,
    ],
  },

  { path: "**", redirectTo: "login" },
];
